import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores';
import styled from 'styled-components';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isLoading, user, verifyToken } = useAuthStore();
  const location = useLocation();

  // Проверяем токен при монтировании
  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  // Показываем загрузку
  if (isLoading) {
    return (
      <LoadingContainer>
        <Spinner />
        <LoadingText>Проверка авторизации...</LoadingText>
      </LoadingContainer>
    );
  }

  // Если не авторизован - редирект на логин
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Если требуется админ, но пользователь не админ
  if (requireAdmin && user?.role !== 'admin') {
    return (
      <ErrorContainer>
        <ErrorIcon>🔒</ErrorIcon>
        <ErrorTitle>Доступ запрещен</ErrorTitle>
        <ErrorText>Требуются права администратора</ErrorText>
      </ErrorContainer>
    );
  }

  return <>{children}</>;
};

// Styled Components

const LoadingContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top-color: #0284c7;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const LoadingText = styled.p`
  font-size: 1rem;
  color: #6b7280;
`;

const ErrorContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const ErrorIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1rem;
`;

const ErrorTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 0.5rem 0;
`;

const ErrorText = styled.p`
  font-size: 1rem;
  color: #6b7280;
  margin: 0;
`;

export default ProtectedRoute;

